<script>
	import { scaleAdOnHover, startAd, stopAd } from '../../../../share/ads';
	import { getText } from '../../../../share/utils';

	let ads = {
		// FLU0298_LED_Screen_Blondine
		blondine: {
			element: false,
			fallbackImgUrl: './../video/FLU0298_LED_Screen_Blondine_Posterbild.webp',
			imageAltText: 'Überflieger - interactive Ad',
			videoUrl: './../video/FLU0298_LED_Screen_Blondine.mp4',
			playTimeMs: 15000,
			playing: false,
			autoStopTimeOut: false,
			pauseImgOffsetS: 4,
			scale: 1,
			origWidth: 1368,
			origHeight: 768
		},
		// FLU0295A_Insta_Story_Ad_portground
		flugzeug: {
			element: false,
			fallbackImgUrl: './../video/FLU0295A_Insta_Story_Ad_portground_1080x1920_Posterbild.webp',
			imageAltText: 'Überflieger - interactive Ad',
			videoUrl: './../video/FLU0295A_Insta_Story_Ad_portground_1080x1920.mp4',
			playTimeMs: 12000,
			playing: false,
			autoStopTimeOut: false,
			pauseImgOffsetS: 4,
			scale: 1,
			origWidth: 438,
			origHeight: 780
		}
	}
</script>

<div class="page-tourism-cloud marginbox">
	<div class="flex structure">
		<div class="flex row structure-1">
			<!-- Beginning - blondine -->
			<div bind:this={ads.blondine.element} class="flex element">
				<div use:scaleAdOnHover={ads.blondine} class="commercial" class:playing={ads.blondine.playing}>
					{#if ads.blondine.playing}
						<video playsinline autoplay on:loadeddata={(e) => {
								e.target.setAttribute('loaded', 'true');
								setTimeout(() => stopAd(ads, ads.blondine, () => ads = ads), ads.blondine.playTimeMs);
							}} loop="true" scrolling="no" src={ads.blondine.videoUrl}
							   style="--bg-image: url('{ads.blondine.fallbackImgUrl}');
								 --scale: {ads.blondine.scale};
								 --origWidth: {ads.blondine.origWidth || 0}px;
								 --origHeight: {ads.blondine.origHeight || 0}px;
							"/>
						<!-- PLAYING -->
					{:else}
						<img loading="lazy" alt={ads.blondine.imageAltText} src={ads.blondine.fallbackImgUrl} on:click={() => startAd(ads.blondine, () => ads = ads)}>
						<!-- NOT PLAYING -->
						<button aria-label="play Ad - {ads.blondine.imageAltText}" class="playbutton"></button>
					{/if}
				</div>
			</div>
			<!-- End - blondine -->
		</div>
		
		<div class="flex col structure-2">
			<!-- Beginning - flugzeug -->
			<div bind:this={ads.flugzeug.element} class="flex element">
				<div use:scaleAdOnHover={ads.flugzeug} class="commercial" class:playing={ads.flugzeug.playing}>
					{#if ads.flugzeug.playing}
						<video playsinline autoplay on:loadeddata={(e) => {
								e.target.setAttribute('loaded', 'true');
								setTimeout(() => stopAd(ads, ads.flugzeug, () => ads = ads), ads.flugzeug.playTimeMs);
							}} loop="true" scrolling="no" src={ads.flugzeug.videoUrl}
							   style="--bg-image: url('{ads.flugzeug.fallbackImgUrl}');
								 --scale: {ads.flugzeug.scale};
								 --origWidth: {ads.flugzeug.origWidth || 0}px;
								 --origHeight: {ads.flugzeug.origHeight || 0}px;
							"/>
						<!-- PLAYING -->
					{:else}
						<img loading="lazy" alt={ads.flugzeug.imageAltText} src={ads.flugzeug.fallbackImgUrl} on:click={() => startAd(ads.flugzeug, () => ads = ads)}>
						<!-- NOT PLAYING -->
						<button aria-label="play Ad - {ads.flugzeug.imageAltText}" class="playbutton"></button>
					{/if}
				</div>
			</div>
			<!-- End - flugzeug -->
		</div>
		
		<div class="flex col structure-3">
			<div class="flex element">
				<img loading="lazy" alt="Überflieger - Bandenwerbung - Ad-Design" src="./../img/11.Ueberflieger/02.cloud/Bandenwerbung_Layout.webp">
			</div>
			<div class="flex element">
				<div class="text">
					<h2>{getText("11.02.01_h2")}</h2>
					<p class="caption">{getText("11.02.02_caption")}</p>
					<p class="caption blue">Project Lead: <a href="//www.zebra.de" target="_blank">Zebra</a></p>
				</div>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.img-single {
		margin: $spacing-mobile $spacing-mobile $media-gap $spacing-mobile;
	}
	
	h2,
	h2 {
		margin-bottom: $media-gap;
	}
	
	.page-tourism-cloud {
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: auto;
			line-height: 0;
		}
		
		.content {
			flex: 1 100%;
		}
		
		.structure {
			flex-flow: row wrap;
		}
		
		.structure-1,
		.structure-2,
		.structure-3 {
			width: 100%;
			padding: 0;
			position: relative;
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
		}
		
		.structure-1 {
			margin-top: $spacing-mobile;
		}
		
		.structure-2 {
			@include for-tablet-portrait-up {
				width: calc(100% / 3);
			}
		}
		
		.structure-3 {
			margin-bottom: $media-gap;
			
			@include for-tablet-portrait-up {
				width: calc(100% / 3 * 2);
				padding-left: $media-gap;
			}
		}
		
		.text {
			margin: 0;
		}

		.commercial video {
			width: 100%;
			height: calc(var(--origHeight) * var(--scale));
			background-image: var(--bg-image);
			background-size: cover;
		}

		:global(.commercial video[loaded]) {
			background-image: none !important;
		}
	}
</style>
